<template>
    <b-form-group
        :description="this.$t('editFields')"
        :label="this.$t('fields')"
        label-for="perPage"
        :label-cols="2"
        :horizontal="true">
        <div class="form-actions">
            <helptip
            helpType="icon"
            tipId="component.settings.list.fields"
            >
                <b-button type="submit" variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
            </helptip>
        </div>
        <main-dialog title="Edit fields in list" v-model="editor.show">
            <b-list-group>
                <b-list-group-item
                v-for="field in appendedFields"
                button
                v-bind:key="field.key"
                @click="fieldEditorShow(field)"
                >
                    {{ $translateLabel(field.label, field.key) }} <span v-if="isListed(field)"> <b-icon icon="check" /> </span>
                </b-list-group-item>
                <b-list-group-item button variant="dark" @click="fieldEditorShowNew()">
                    {{ $t('add') }}
                </b-list-group-item>
            </b-list-group>

            <main-dialog :title="fieldEditor.title" v-model="fieldEditor.show">
                <b-form-group
                    :label="$t('key')"
                    v-if="fieldEditor.new"
                    label-for="key">
                    <b-form-input v-model="fieldEditor.field.key" :required="true"></b-form-input>
                </b-form-group>

                <Texti18n v-model="fieldEditor.field.label" :label="$t('label')"  :required="true"></Texti18n>
                
                <b-form-group
                    :label="this.$t('sortOrder')"
                    label-for="sortOrder">
                    <b-form-input type="number" v-model.number="fieldEditor.field.sortOrder"></b-form-input>
                </b-form-group>
            
                <b-form-group
                    :label="this.$t('formatter')"
                    label-for="formatter"
                    v-if="showFormatter()"
                    >
                    <div class="form-actions">
                        <b-button id="editFieldsButton" type="submit" variant="success" @click="formatterEditor.show = true">{{ $t('openEditor') }}</b-button>
                    </div>
                    <main-dialog size="lg" title="Formatter editor" v-model="formatterEditor.show">
                        <CodeEditor v-model="fieldEditor.field.formatter" :options="formatterEditor.options" :withButton="false"></CodeEditor>
                    </main-dialog>
                </b-form-group>
                <b-form-group
                    :label="this.$t('template')"
                    label-for="template">

                        <Entrypoints v-model="entrypoint" />

                </b-form-group>

                <template #modal-footer>
                    <b-button variant="danger" @click="fieldEditorCancel()" v-if="!fieldEditor.field.new">{{ $t('remove') }}</b-button>
                    <b-button variant="primary" @click="fieldEditorSave()">{{ $t('save') }}</b-button>
                </template>
            </main-dialog>
        </main-dialog>
    </b-form-group>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import { deepCopyObject } from "../../../shared/utils"
// require component
import CodeEditor from '../../form/Editor/Code'
import Entrypoints from './Entrypoints'
import CustomTemplate from "./Template"
import { uniqBy } from 'lodash'

// elements
import Helptip from '../../elements/Helptip.vue'
import Texti18n from '../../form/Texti18n.vue'

export default {
    components: {
        cSwitch,
        CodeEditor,
        Helptip,
        Entrypoints,
        CustomTemplate,
        Texti18n
    },
    props: {
        component: {
            type: Object
        },
        list: {
            type: Object
        },
        value: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            editor: {
                show: false
            },
            formatterEditor: {
                show: false,
            },
            fieldEditor: {
                show: false,
                title: "",
                new: false,
                field: {
                    label: null,
                    key: "",
                    formatter: null,
                    provided_template_component: null,
                    component_template: null,
                }
            }
        }
    },
    computed: {
        entrypoint: {
            get() {
                return {
                    component: this.fieldEditor.field.provided_template_component,
                    template: this.fieldEditor.field.component_template
                }
            },

            set(v) {
                this.fieldEditor.field = Object.assign({}, this.fieldEditor.field, {
                    provided_template_component: v.component,
                    component_template: v.template
                })

                console.log("Entrypoint set", this.fieldEditor.field)
            }
            
        },

        settings() {
            return this.component.settings || {}
        },

        fieldsListed: {
            get() {
                return this.value || []
            },

            set(v) {
                this.$emit('input', v)
            }
        },

        appendedFields() {
            let fields = deepCopyObject(this.settings.fields) || []

            fields.unshift({
                name: "UUID",
                key: "uuid"

            })

            if (this.settings.model.disable) {
                fields.push({
                    name: "Disabled at",
                    key: "disabled_at"
                })
            }

            if (this.settings.model.timestamps) {
                fields.push({
                    name: "Created at",
                    key: "created_at"
                })

                fields.push({
                    name: "Updated at",
                    key: "updated_at"
                })
            }

            fields = uniqBy(fields.concat(this.settings.list.fields), 'key')

            return fields.filter(f => f).map(f => {
                const { list } = this.settings || {}
                let { fields } = list || {}
                if (!fields) fields = []

                console.log("Fields", f)
                const listField = fields.find(lf => lf.key === f.key) || {}

                if (!listField) return {
                    label: f.label || f.name,
                    key: f.key,
                    formatter: null,
                    provided_template_component: null,
                    component_template: null,
                    sortOrder: 0
                }

                return {
                    label: listField.label || f.label,
                    key: f.key,
                    formatter: f.formatter || null,
                    provided_template_component: f.provided_template_component || null,
                    component_template: f.component_template || null,
                    sortOrder: f.sortOrder || 0
                }
            }).sort((a, b) => {
                return a.sortOrder - b.sortOrder
            });
        }
    },
    methods: {
        isListed(field) {
            return this.fieldsListed.find(item => {
                return item.key == field.key
            })
        },

        buttonVariant(field) {
            if (this.isListed(field)) {
                return "success"
            }
        },

        fieldEditorShowNew() {
            this.fieldEditor.show = true
            this.fieldEditor.title = this.$t('addField')
            this.fieldEditor.new = true
            this.fieldEditor.field = {
                label: {
                    locales: {},
                },
                key: null,
                formatter: null,
                provided_template_component: null,
                component_template: null,
            }
        },

        fieldEditorShow(field) {
            this.fieldEditor.show = true
            this.fieldEditor.new = false
            this.fieldEditor.title = field.name
            this.fieldEditor.field = this.isListed(field)

            if (this.fieldEditor.field === undefined) {
                this.fieldEditor.field = {
                    label: field.label,
                    key: field.key,
                    formatter: null,
                    provided_template_component: null,
                    component_template: null,
                }
            }
        },

        fieldEditorSave() {
            let currentField = this.fieldEditor.field

            console.log("Current field", currentField)

            if (!this.isListed(currentField)) {
                this.fieldsListed.push(currentField)
            } else {
                this.fieldsListed = this.fieldsListed.map(f => {
                    if (f.key === currentField.key) {
                        return currentField
                    }

                    return f
                })
            }
            
            this.fieldEditor.show = false
        },

        fieldEditorCancel() {
            let currentField = this.fieldEditor.field

            let fields = this.fieldsListed.filter(f => {
                return f.key != currentField.key
            })

            this.$emit("input", fields)

            this.fieldEditor.show = false
        },

        showFormatter() {
            let key = this.fieldEditor.field.key
            if (this.settings.fields !== null) {
                let field = this.settings.fields.find(f => {
                    return f.key == key
                })

                if (field !== undefined) {
                    if (field.module == 'input' && field.type == 'image') {
                        return false;
                    }

                }
            }

            return true;
        }
    }
}
</script>
